import { render, staticRenderFns } from "./ProjectNavigation.vue?vue&type=template&id=0709cef7&scoped=true&"
import script from "./ProjectNavigation.vue?vue&type=script&lang=js&"
export * from "./ProjectNavigation.vue?vue&type=script&lang=js&"
import style0 from "./ProjectNavigation.vue?vue&type=style&index=0&id=0709cef7&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0709cef7",
  null
  
)

export default component.exports